import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/customers/billing-entity-bank-account/:bankAccountId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    bankAccountId: string;
}
const mutationFn = ({ bankAccountId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { bankAccountId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteBillingEntityBankAccount };
